import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import CattLogo from "@/components/CattLogo";

export default function Footer() {
  const { t } = useLang();
  const F = t.footer;

  return (
    <footer data-testid="site-footer" className="bg-[#0a0a0c]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-3 mb-6 text-white">
              <CattLogo size={32} />
              <div className="flex items-baseline gap-3">
                <span className="font-display font-bold text-lg tracking-tight leading-none">CATT</span>
                <span className="w-px h-4 bg-white/25" />
                <span className="font-ko font-bold text-[15px] tracking-[-0.01em] leading-none text-white/85">
                  사용성평가연구센터
                </span>
              </div>
            </div>
            <p className="text-white/55 text-sm leading-relaxed max-w-md">{F.desc}</p>
          </div>

          <FooterCol
            title={F.research}
            items={t.domains.cards.map((c) => c.title)}
          />
          <FooterColLinks
            title={F.lab}
            items={[
              { label: F.lab_items[0], href: "/#methods" },
              { label: F.lab_items[1], href: "/#lab" },
              { label: F.lab_items[2], href: "/publications", route: true },
              { label: F.lab_items[3], href: "/#contact" },
            ]}
          />
          <FooterCol
            title={F.contact}
            items={["segeberg@kmu.ac.kr", "053-580-8980", "CATT · Keimyung University"]}
          />
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="font-mono text-[10px] tracking-widest uppercase text-white/35">
            © {new Date().getFullYear()} CATT · Center for Advanced Technology and Testing · {F.rights}
          </div>
          <div className="font-mono text-[10px] tracking-widest uppercase text-white/35 flex items-center gap-6 flex-wrap">
            <span>ISO 9241-210</span>
            <span>IEC 62366-1</span>
            <span className="flex items-center gap-2">
              <span className="ticker-tick" /> {t.nav.status}
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div className="col-span-6 lg:col-span-2">
      <div className="label-mono mb-5">{title}</div>
      <ul className="space-y-3">
        {items.map((it) => (
          <li key={it} className="text-sm text-white/65 hover:text-white transition-colors">
            {it}
          </li>
        ))}
      </ul>
    </div>
  );
}

function FooterColLinks({ title, items }) {
  return (
    <div className="col-span-6 lg:col-span-2">
      <div className="label-mono mb-5">{title}</div>
      <ul className="space-y-3">
        {items.map((it) =>
          it.route ? (
            <li key={it.label}>
              <Link to={it.href} className="text-sm text-white/65 hover:text-white transition-colors">
                {it.label}
              </Link>
            </li>
          ) : (
            <li key={it.label}>
              <a href={it.href} className="text-sm text-white/65 hover:text-white transition-colors">
                {it.label}
              </a>
            </li>
          )
        )}
      </ul>
    </div>
  );
}
